module.exports = __webpack_public_path__ + "static/unity-64ea551bb332093ad91cf4bb78f9558b.svg";